import { render, staticRenderFns } from "./AtomTinymcePrimary.vue?vue&type=template&id=876d5462&"
import script from "./AtomTinymcePrimary.vue?vue&type=script&lang=js&"
export * from "./AtomTinymcePrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports